import allStarRed from '../../../Assets/Images/shops/mdu/Mdu1.jpg';
import jordans from '../../../Assets/Images/shops/mdu/Mdu2.jpg';
import allStarBlack from '../../../Assets/Images/shops/mdu/Mdu3.jpg';
import allStarRed1 from '../../../Assets/Images/shops/mdu/Mdu4.jpg';
import jordans1 from '../../../Assets/Images/shops/mdu/Mdu5.jpg';
import allStarBlack1 from '../../../Assets/Images/shops/mdu/Mdu6.jpg';

const shopsData = [
  {
    name: 'all-Star Red',
    image: allStarRed,
    price: 'R1600',
    shopName: 'shoe freaks',
  },
  {
    name: 'jordans',
    image: jordans,
    price: 'R1600',
    shopName: 'shoe freaks',
  },
  {
    name: 'all-Star Black',
    image: allStarBlack,
    price: 'R1600',
    shopName: 'shoe freaks',
  },
  {
    name: 'all-Star Red',
    image: allStarRed,
    price: 'R650',
    shopName: 'shoe freaks',
  },
  {
    name: 'Air-Force 1',
    image: jordans1,
    price: 'R1600',
    shopName: 'shoe freaks',
  },
  {
    name: 'all-Star',
    image: allStarBlack1,
    price: 'R650',
    shopName: 'shoe freaks',
  },
];
export default shopsData;
